import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type Language = 'en' | 'es';

/**
 * Service for managing the current language of the application.
 */
@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private readonly LANG_STORAGE_KEY = 'ml_lang';

  private _currentLanguageSubject = new BehaviorSubject<Language>(
    this._getStoredLanguage()
  );

  public currentLanguage$ = this._currentLanguageSubject.asObservable();

  get language(): Language {
    return this._currentLanguageSubject.value;
  }

  /**
   * Sets the current language for the application.
   * @param language The language to set.
   */
  public setLanguage(language: Language): void {
    this._storeLanguage(language);
  }

  /**
   * Retrieves the stored language from local storage.
   * @returns The stored language as a Language enum value.
   */
  private _getStoredLanguage(): Language {
    return localStorage.getItem(this.LANG_STORAGE_KEY) as Language;
  }

  /**
   * Stores the selected language in local storage.
   * @param language The language to store.
   */
  private _storeLanguage(language: Language): void {
    localStorage.setItem(this.LANG_STORAGE_KEY, language);
  }
}
